(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["phuc-an-contact-actions"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-phuc-an-conversion]');
    if (link && typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', { send_to: link.dataset.phucAnConversion, value: 0, currency: 'VND' });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
